import { createInProgressItem, getInProgressItemCount, getOrderItemCountByItemId, updateInProgressItemQuantity } from '@vista/omnichannel-components-domain';
export const setInitialQuantity = (sellableItem, ticketQuantity) => {
    const order3dGlassesCount = getOrderItemCountByItemId(sellableItem.itemId);
    if (order3dGlassesCount)
        return;
    const inProgressItemCount = getInProgressItemCount();
    if (!inProgressItemCount)
        createInProgressItem(sellableItem);
    updateInProgressItemQuantity(sellableItem, ticketQuantity);
};
